window.surgicalModel = {

    saveSurgicalRecord: function (params, callback) {
        //debug.log('saveSurgicalRecord: ', params, callback)
        $.post('/operating_room/operating_theater/save_surgical_record', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
                if (callback) {
                    callback(data.success, data);
                }
            })
            .fail(function (xhr, status, error) {
                if (callback) {
                    callback(error, null);
                }
            });
    }
};